export const ScmpSubscriptionsKey = "scmp_subscriptions";
